import { render } from "./IClassroomPicker.vue?vue&type=template&id=4f55dcb6"
import script from "./IClassroomPicker.vue?vue&type=script&lang=js"
export * from "./IClassroomPicker.vue?vue&type=script&lang=js"

import "./IClassroomPicker.vue?vue&type=style&index=0&id=4f55dcb6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__